import { render, staticRenderFns } from "./RetireDepartmentDialog.vue?vue&type=template&id=4fd2c64a"
import script from "./RetireDepartmentDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./RetireDepartmentDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports